import apiPaths from '../api-paths';

export default {
  listInsuranceTitleCodes() {
    return axios.get(`${ apiPaths.STAFF }/agreements/insurance-title-codes?list=true`);
  },
  listRetirementEntitlementCodes() {
    return axios.get(`${ apiPaths.STAFF }/agreements/retirement-entitlement-codes?list=true`);
  },
  listDisabilityLevelCodes() {
    return axios.get(`${ apiPaths.STAFF }/agreements/disability-level-codes?list=true`);
  },
};
